/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {WPElement} Element to render.
 */
export default function save(props) { console.log('yoyoma');
    const { attributes, setAttributes, blockProps, clientId, className } = props;
    const { header, subHeader } = attributes;

    return (
        <div { ...blockProps }>
            <div class="momo-acg-ai-form-container">
                <span class="momo-form-working"></span>
                <h3>{header}</h3>
                <h4>{subHeader}</h4>
                <span class="momo-acg-form-hr"></span>
                <div class="momo-acg-ai-innerblocks-fe">
                <InnerBlocks.Content />
                </div>
            </div>
        </div>
    );
}
